import { Controller } from "@hotwired/stimulus"

const DISMISSED_KEY = "sw-update-dismissed"

export default class extends Controller {
  connect() {
    this.handleUpdateAvailable = () => this.show()
    document.addEventListener("sw:update-available", this.handleUpdateAvailable)
  }

  disconnect() {
    document.removeEventListener("sw:update-available", this.handleUpdateAvailable)
  }

  show() {
    if (sessionStorage.getItem(DISMISSED_KEY)) return

    this.element.hidden = false
  }

  async reload() {
    if (!("serviceWorker" in navigator)) return

    const registration = await navigator.serviceWorker.getRegistration()
    if (registration && registration.waiting) {
      navigator.serviceWorker.addEventListener("controllerchange", () => {
        window.location.reload()
      }, { once: true })
      registration.waiting.postMessage({ type: "SKIP_WAITING" })
    } else {
      window.location.reload()
    }
  }

  dismiss() {
    this.element.hidden = true
    sessionStorage.setItem(DISMISSED_KEY, "true")
  }
}
